import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { TrackingService } from '@core/services';

@Component({
    selector: 'gh-sticky-banner',
    templateUrl: 'sticky-banner.component.html',
    standalone: false
})

export class StickyBannerComponent implements OnInit {
  website = environment.website;
  signup = environment.signup;
  root = environment.root;
  isUs = environment.locale === 'en-us';

  constructor(
    private trackingService: TrackingService
  ) { }

  ngOnInit() { }

  ctaClick(label: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'cta_click',
      events: {
        click_text: label,
        feature: 'blog',
        environment: environment.env,
        location
      }
    });
  }
}